var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserInCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 18.5521H15.8333C15 18.5521 14.2083 18.875 13.625 19.4583L11.8437 21.2187C11.0312 22.0208 9.70835 22.0208 8.89585 21.2187L7.11458 19.4583C6.53124 18.875 5.72917 18.5521 4.90625 18.5521H4.125C2.39583 18.5521 1 17.1667 1 15.4583V4.09372C1 2.38539 2.39583 1 4.125 1H16.625C18.3542 1 19.75 2.38539 19.75 4.09372V15.4583C19.75 17.1563 18.3542 18.5521 16.625 18.5521Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3773 9.32191C11.7177 9.32191 12.8044 8.23525 12.8044 6.89481C12.8044 5.55437 11.7177 4.46777 10.3773 4.46777C9.03686 4.46777 7.9502 5.55437 7.9502 6.89481C7.9502 8.23525 9.03686 9.32191 10.3773 9.32191Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5443 15.218C14.5443 13.343 12.6797 11.8223 10.3776 11.8223C8.07552 11.8223 6.21094 13.343 6.21094 15.218",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInCard);
export default __webpack_public_path__ + "static/media/user_in_card.1867a3328eef3e034a3bbdb2ca737502.svg";
export { ForwardRef as ReactComponent };